import { TableHeading } from "../../../components/common/table/TableDesign";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const vehicleTypeFields = [
  {
    id: "vehicle_type",
    label: "Vehicle Type",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 6,
    isRequired: true,
  },
  {
    id: "fuel_type",
    label: "Fuel Type",
    placeHolder: "Select Fuel Type",
    type: "select",
    options: ["Petrol", "Diesel", "Electric", "Hybrid"],
    md: 6,
  },
  {
    id: "description",
    label: "Description",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 150,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
      isRequired: true,
  },
  {
    id: "capacity",
    label: "Capacity (m³)",
    placeholder: "Capacity",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 6,
  },
  {
    id: "seats",
    label: "Seats",
    placeholder: "Seats",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.NUMERIC,
    md: 6,
  },

  {
    id: "efficiency",
    label: "Efficiency (MPG)",
    placeholder: "Efficiency",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 6,
  },
  {
    id: "cost_per_mile",
    label: "Cost Per Mile",
    placeholder: "Cost Per Mile",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 6,
  },
];

export const vehicleFields = [
  {
    id: "name",
    label: "Vehicle Name",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 6,
  },
  {
    id: "reg_number",
    label: "Reg. Number",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 6,
  },
  {
    id: "vehicle_type",
    label: "Vehicle Type",
    placeHolder: "",
    type: "select",
    isRequired: true,
    options: [],
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 6,
  },
  {
    id: "fuel_type",
    label: "Fuel Type",
    placeHolder: "Select Fuel Type",
    type: "select",
    options: ["Petrol", "Diesel", "Electric", "Hybrid"],
    md: 6,
  },

  {
    id: "capacity",
    label: "Capacity (m³)",
    placeholder: "Capacity",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 6,
  },
  {
    id: "seats",
    label: "Seats",
    placeholder: "Seats",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.NUMERIC,
    md: 6,
  },

  {
    id: "efficiency",
    label: "Efficiency (MPG)",
    placeholder: "Efficiency",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 6,
  },
  {
    id: "cost_per_mile",
    label: "Cost Per Mile",
    placeholder: "Cost Per Mile",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
    md: 6,
  },
  {
    id: "mot_due",
    label: "MOT Due Date",
    placeholder: "MOT Due Date",
    type: "date",
    md: 6,
  },
  {
    id: "service_due",
    label: "Service Due Date",
    placeholder: "Service Due Date",
    type: "date",
    md: 6,
  },
];

export const vehicleTypeDetailsFormData = [
  {
    id: "vehicle_type",
    label: "Type :",
    placeHolder: "Enter type",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "fuel_type",
    label: "Fuel Type :",
    tooltipText: "Fuel Type",
    placeHolder: "Select",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "description",
    label: "Description",
    placeHolder: "Enter description",
    type: "viewField",
    md: 12,
    isFlexField: true,
  },
  {
    id: "seats",
    label: "Seats :",
    placeHolder: "Enter seats",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "capacity",
    label: "Capacity (m³) :",
    placeHolder: "Enter capacity",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "efficiency",
    label: "Efficiency (MPG) :",
    placeHolder: "Enter efficiency",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "cost_per_mile",
    label: "Cost Per Mile :",
    placeHolder: "Enter cost per mile",
    type: "viewField",
    md: 6,
    isFlexField: true,
    prefixIcon: '£'
  },
];

export const vehicleDetailsFormData = [
  {
    id: "name",
    label: "Name :",
    placeHolder: "Enter name",
    type: "viewField",
    md: 4,
    isFlexField: true,
  },
  {
    id: "vehicle_type",
    label: "Type :",
    placeHolder: "Enter type",
    type: "viewField",
    md: 6,
    isFlexField: true,
  },
  {
    id: "reg_number",
    label: "Reg. Number :",
    placeHolder: "Enter reg number",
    type: "viewField",
    md: 4,
    isFlexField: true,
  },
  {
    id: "fuel_type",
    label: "Fuel Type :",
    tooltipText: "Fuel Type",
    placeHolder: "Select",
    type: "viewField",
    md: 4,
    isFlexField: true,
  },
  {
    id: "seats",
    label: "Seats :",
    placeHolder: "Enter seats",
    type: "viewField",
    md: 4,
    isFlexField: true,
  },
  {
    id: "capacity",
    label: "Capacity (m³) :",
    placeHolder: "Enter capacity",
    type: "viewField",
    md: 4,
    isFlexField: true,
  },
  {
    id: "efficiency",
    label: "Efficiency (MPG) :",
    placeHolder: "Enter efficiency",
    type: "viewField",
    md: 4,
    isFlexField: true,
  },
  {
    id: "cost_per_mile",
    label: "Cost Per Mile :",
    placeHolder: "Enter cost per mile",
    type: "viewField",
    md: 4,
    isFlexField: true,
    prefixIcon: '£'
  },
  {
    id: "mot_due",
    label: "Mot Due Date :",
    placeHolder: "Enter mot due date",
    type: "viewField",
    md: 4,
    isFlexField: true,
  },
  {
    id: "service_due",
    label: "Service Due Date :",
    placeHolder: "Enter service due date",
    type: "viewField",
    md: 5,
    isFlexField: true,
  },
];

export const FUEL_FORM = [
  {
    id: "petrol_rate",
    label: "Petrol Rate Per Litre :",
    placeHolder: "Enter petrol rate",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "diesel_rate",
    label: "Diesel Rate Per Litre :",
    placeHolder: "Enter diesel rate",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "electric_rate",
    label: "Electric Rate Per kWh :",
    placeHolder: "Enter electric rate",
    type: "text",
    md: 3,
    inputProps: {
      maxLength: 6,
    },
    patternAllowed: patternConstant?.PRICE,
  },
];
